import { ApiReferenceReact } from "@scalar/api-reference-react"
import { createFileRoute } from "@tanstack/react-router"
import { useEffect } from "react"

import { getAPIBaseUrl } from "~/lib/env"
import CustomHead from "~/components/SEOHead/CustomHead"

function DocsPage() {
  useEffect(() => {
    // eslint-disable-next-line @aix/no-inline-dynamic-imports -- lazy CSS for this page only
    void import("@scalar/api-reference-react/style.css")

    // Add a class to body to scope Scalar styles
    document.body.classList.add("scalar-docs-page")

    // Cleanup function to remove class when component unmounts
    return () => {
      document.body.classList.remove("scalar-docs-page")
    }
  }, [])

  return (
    <>
      <CustomHead
        title="VidMax API Documentation — OpenAPI v1"
        description="The canonical VidMax public REST API v1 contract for developers and AI agents."
        url="https://vidmax.ai/docs"
      />

      <div className="w-full h-full">
        <ApiReferenceReact
          configuration={{
            url: `${getAPIBaseUrl()}/api/v1/openapi.json`,
          }}
        />
      </div>
    </>
  )
}

export const Route = createFileRoute("/docs")({
  component: DocsPage,
})
